import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider, MenuItem, Grid, InputLabel, TextField } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from "material-table";
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import tokenDecoder from '../../../utils/tokenDecoder';
import xlsx from 'json-as-xlsx';
import { CustomMultiSelect } from 'src/utils/CustomMultiSelect';
import CloseIcon from '@material-ui/icons/Close';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorRecord: {
        backgroundColor: 'green'
    },
    deleteIcon: {
        color: red[500],
        '&:hover': {
            color: red[700],
        }
    }
}));

const screenCode = 'WAREHOUSESKUMAPPING';
export default function WarehouseSKUMapping() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const [factories, setFactories] = useState([]);
    const [groups, setGroups] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [skuArray, setSkuArray] = useState([]);
    const [IDDataForDeduction, setIsIDDataForDeduction] = useState(null);
    const [SKUCategoryNames, setSKUCategoryNames] = useState();
    const [mappingViewData, setMappingData] = useState([])
    const [WarehouseSKUMppingDetails, setWarehouseSKUMppingDetails] = useState({
        groupID: 0,
        factoryID: 0,
        warehouseID: 0,
        skuCategoryID: 0,
        budgetCodeID: 0,
        skuMasterID: []
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        factoryName: '',
        warehouseName: '',
        AccountCode: '',
        SKUCategory: '',
    });
    const [selectedWarehouseID, setSelectedWarehouseID] = useState(null);
    const [budgetCodes, setBudgetCodes] = useState([]);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    let encrypted = "";
    const handleClick = () => {
        encrypted = btoa('0');
        navigate('/app/warehouseSkuMapping/addEdit/' + encrypted);
    }

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isRegionFilterEnabled: false
    });

    //For multiple dropdown
    const [selectedOptions, setSelectedOptions] = useState([]);
    const getOptionLabel = option => `${option.label}`;
    const getOptionDisabled = option => option.value === "foo";
    const handleToggleOption = selectedOptions =>
        setSelectedOptions(selectedOptions);
    const handleClearOptions = () => setSelectedOptions([]);
    const handleSelectAll = isSelected => {
        if (isSelected) {
            setSelectedOptions(skuArray);
        } else {
            handleClearOptions();
        }
    };

    const valuesArray = selectedOptions.map(option => option.value);
    useEffect(() => {
        setWarehouseSKUMppingDetails({ ...WarehouseSKUMppingDetails, skuMasterID: valuesArray })
        setMappingData([]);
    }, [selectedOptions])

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getBudgetCodeDetails());
    }, []);

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...WarehouseSKUMppingDetails,
            warehouseID: 0,
            budgetCodeID: 0,
            skuCategoryID: 0,
        });
        setSKUCategoryNames([]);  
        setSkuArray([]);  
        setSelectedOptions([]);  
        trackPromise(getfactoriesForDropDown());
    }, [WarehouseSKUMppingDetails.groupID])

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...WarehouseSKUMppingDetails,
            warehouseID: 0,
            budgetCodeID: 0,
            skuCategoryID: 0,

        })
    }, [WarehouseSKUMppingDetails.factoryID])

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...WarehouseSKUMppingDetails,
            budgetCodeID: 0,
            skuCategoryID: 0,

        })
    }, [WarehouseSKUMppingDetails.warehouseID])

    useEffect(() => {
        setWarehouseSKUMppingDetails({
            ...WarehouseSKUMppingDetails,
            skuCategoryID: 0,

        })
    }, [WarehouseSKUMppingDetails.budgetCodeID])

    useEffect(() => {
        setSelectedOptions([]);
    }, [WarehouseSKUMppingDetails.skuCategoryID])

    // useEffect(() => {
    //     if (WarehouseSKUMppingDetails.budgetCodeID > 0) {
    //         trackPromise(getSKUCategoryNamesForDropdown());
    //     };
    // }, [WarehouseSKUMppingDetails.budgetCodeID]);

    useEffect(() => {
        if (WarehouseSKUMppingDetails.skuCategoryID > 0) {
            trackPromise(getSKUNamesForDropdown());
        };
    }, [WarehouseSKUMppingDetails.skuCategoryID]);

    useEffect(() => {
        trackPromise(GetWarehouseForDropDown());
    }, [WarehouseSKUMppingDetails.factoryID]);

    useEffect(() => {
        trackPromise(GetWarehouseForDropDown());
    }, [WarehouseSKUMppingDetails.factoryID]);

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('accountType-listing-page-search-parameters-id')
        );
        getPermissions(IDdata);
    }, []);

    useEffect(() => {
        if (IDDataForDeduction !== null) {
            getData();
        }
    }, [IDDataForDeduction]);

    useEffect(() => {
        sessionStorage.removeItem(
            'accountType-listing-page-search-parameters-id'
        );
    }, []);

    useEffect(() => {
        if (WarehouseSKUMppingDetails.budgetCodeID == 0) {
            setWarehouseSKUMppingDetails((prev) => ({
                ...prev,
                skuCategoryID: 0
            }))
            setSKUCategoryNames([]);
        };
    }, [WarehouseSKUMppingDetails.budgetCodeID]);

    useEffect(() => {
        if (WarehouseSKUMppingDetails.budgetCodeID > 0 && WarehouseSKUMppingDetails.factoryID > 0) {
            trackPromise(getSKUCategoryNamesForDropdown());
        };
    }, [WarehouseSKUMppingDetails.budgetCodeID, WarehouseSKUMppingDetails.factoryID]);

    useEffect(() => {
        if (WarehouseSKUMppingDetails.skuCategoryID == 0) {
            setSkuArray([])
            setSelectedOptions([])
        };
    }, [WarehouseSKUMppingDetails.skuCategoryID]);

    useEffect(() => {
        setFactories([]);
    }, [WarehouseSKUMppingDetails.groupID])

    async function getPermissions(IDdata) {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWWAREHOUSESKUMAPPING');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        const initialValues = IDdata === null;
        if (initialValues) {
            setWarehouseSKUMppingDetails({
                ...WarehouseSKUMppingDetails,
                groupID: parseInt(tokenService.getGroupIDFromToken()),
                factoryID: parseInt(tokenService.getFactoryIDFromToken()),
            })
        }
        else {
            setWarehouseSKUMppingDetails({
                ...WarehouseSKUMppingDetails,
                groupID: parseInt(IDdata.groupID),
                factoryID: parseInt(IDdata.factoryID),
            })
            setIsIDDataForDeduction(IDdata)
        }
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getfactoriesForDropDown() {
        var response = await services.getfactoriesForDropDown(WarehouseSKUMppingDetails.groupID);
        setFactories(response);
    };

    async function GetWarehouseForDropDown() {
        const warehouses = await services.getWarehouseForDropDown(WarehouseSKUMppingDetails.factoryID);
        setWarehouses(warehouses);
    }

    async function getBudgetCodeDetails() {
        var response = await services.getBudgetCodeDetails();
        setBudgetCodes(response);
    }

    // async function getSKUCategoryNamesForDropdown() {
    //     const SKUCategoryNames = await services.GetSKUCategoryNamesByBudjetID(WarehouseSKUMppingDetails.budgetCodeID, WarehouseSKUMppingDetails.groupID);
    //     setSKUCategoryNames(SKUCategoryNames);
    // }

    async function getSKUCategoryNamesForDropdown() {
        const SKUCategoryNames = await services.GetSKUCategoryNamesByBudjetID(
            WarehouseSKUMppingDetails.budgetCodeID,
            WarehouseSKUMppingDetails.groupID,
            WarehouseSKUMppingDetails.factoryID  // Add factory parameter
        );
        setSKUCategoryNames(SKUCategoryNames);
    }

    async function getSKUNamesForDropdown() {
        const sku = await services.GetSKUNamesByCategoryID(WarehouseSKUMppingDetails.skuCategoryID);
        const validSkuEntries = Object.entries(sku).filter(([key, value]) => key && value);
        const newSkuArray = validSkuEntries.map(([key, value]) => ({
            value: key,
            label: value
        }));
        setSkuArray(newSkuArray);
        setSelectedOptions([]);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    const generateFactoryDropDownMenu = (data) => {
        return data ? data.map(({ id, name }) => (
            <MenuItem key={id} value={id}>{name}</MenuItem>
        )) : [];
    };

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setWarehouseSKUMppingDetails({
            ...WarehouseSKUMppingDetails,
            [e.target.name]: value
        });
        setMappingData([]);
    }

    async function getData() {
        getSelectedDropdownValues();
        let model = {
            groupID: parseInt(WarehouseSKUMppingDetails.groupID),
            factoryID: parseInt(WarehouseSKUMppingDetails.factoryID),
            warehouseID: parseInt(WarehouseSKUMppingDetails.warehouseID),
            skuCategoryID: parseInt(WarehouseSKUMppingDetails.skuCategoryID),
            budgetCodeID: parseInt(WarehouseSKUMppingDetails.budgetCodeID),
            sKUMasterID: WarehouseSKUMppingDetails.skuMasterID.map(String).join(",")
        }
        let response = await services.GetMappingDetails(model);
        if (response.statusCode == "Success" && response.data.length != 0) {
            setMappingData(response.data)
        }
        else {
            alert.error(response.message)
            clearFields();
        }
    }

    async function handleClickDelete(rowData) {
        setSelectedWarehouseID(rowData.warehouseSKUMappingID);
        setDeleteConfirmationOpen(true);
    }

    const handleConfirmDelete = async () => {
        setDeleteConfirmationOpen(false);

        let model = {
            warehouseSKUMppingID: selectedWarehouseID,
            modifiedDate: new Date().toISOString(),
            modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        };
        const res = await services.DeleteMappingDetails(model);

        if (res.statusCode === "Success") {
            alert.success(res.message);
            trackPromise(getData());
        } else {
            alert.error(res.message);
        }
    };

    const handleCancelDelete = () => {
        setDeleteConfirmationOpen(false);
    };

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                        isEdit={true}
                        toolTiptitle={"Add Warehouse SKU Mapping"}
                    />
                </Grid>
            </Grid>
        )
    }

    function clearFields() {
        setWarehouseSKUMppingDetails({
            ...WarehouseSKUMppingDetails
        });
        setMappingData([]);
    }

    function getSelectedDropdownValues() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups[WarehouseSKUMppingDetails.groupID],
            factoryName: factories[WarehouseSKUMppingDetails.factoryID],
            warehouseName: warehouses[WarehouseSKUMppingDetails.warehouseID],
            AccountCode: budgetCodes[WarehouseSKUMppingDetails.budgetCodeID],
            SKUCategory: SKUCategoryNames[WarehouseSKUMppingDetails.skuCategoryID] == undefined ? '-' : SKUCategoryNames[WarehouseSKUMppingDetails.skuCategoryID],
        });
    }
    async function createDataForExcelTransaction(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Warehouse': x.warehouseName || '-',
                    'Account Code Name': x.budgetCodeName || '-',
                    'SKU Category': x.skuCategoryName || '-',
                    'SKU': x.skuMasterName || '-',
                    'Purchase Category': x.purchaseCategoryName || '-',
                    'Store Warehouse': x.storeWarehouseName || '-'
                }
                res.push(vr);
            });

            res.push({
                'Warehouse': '',
                'Account Code Name': '',
                'SKU Category': '',
                'SKU': '',
                'Purchase Category': '',
                'Store Warehouse': ''
            });
            res.push({
                'Warehouse': 'Group',
                'Account Code Name': selectedSearchValues.groupName,
                'SKU Category': '',
                'SKU': '',
                'Purchase Category': '',
                'Store Warehouse': ''
            });

            res.push({
                'Warehouse': 'Factory',
                'Account Code Name': selectedSearchValues.factoryName,
                'SKU Category': '',
                'SKU': '',
                'Purchase Category': '',
                'Store Warehouse': ''
            });

            res.push({
                'Warehouse': 'Warehouse',
                'Account Code Name': selectedSearchValues.warehouseName != undefined ? selectedSearchValues.warehouseName : 'All',
                'SKU Category': '',
                'SKU': '',
                'Purchase Category': '',
                'Store Warehouse': ''
            });

            res.push({
                'Warehouse': 'Account Code Name',
                'Account Code Name': selectedSearchValues.AccountCode != '--Select Account Code--' ? selectedSearchValues.AccountCode : 'All',
                'SKU Category': '',
                'SKU': '',
                'Purchase Category': '',
                'Store Warehouse': ''
            });

            res.push({
                'Warehouse': '',
                'Account Code Name': '',
                'SKU Category': '',
                'SKU': '',
                'Purchase Category': '',
                'Store Warehouse': ''
            });
        }
        return res;
    }
    async function createFile() {
        var file = await createDataForExcelTransaction(mappingViewData);
        var settings = {
            sheetName: 'Warehouse SKU Mapping Details',
            fileName: 'Warehouse SKU Mapping Details - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + (selectedSearchValues.warehouseName != undefined ? selectedSearchValues.warehouseName : '') + (selectedSearchValues.AccountCode != '--Select Account Code--' ? (' - ' + selectedSearchValues.AccountCode) : ''),
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = [];
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Warehouse SKU Mapping Details',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }


    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title="Warehouse SKU Mapping"
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            factoryID: WarehouseSKUMppingDetails.factoryID,
                            warehouseID: WarehouseSKUMppingDetails.warehouseID,
                            skuMasterID: WarehouseSKUMppingDetails.skuMasterID,
                            skuCategoryID: WarehouseSKUMppingDetails.skuCategoryID,
                            groupID: WarehouseSKUMppingDetails.groupID,
                            budgetCodeID: WarehouseSKUMppingDetails.budgetCodeID,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group required').min(1, 'Group is required'),
                                factoryID: Yup.number().required('Factory required').min(1, 'Factory is required'),
                            })
                        }
                        onSubmit={getData}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle("Warehouse SKU Mapping")}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={2}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={WarehouseSKUMppingDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            size='small'
                                                            name="factoryID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={WarehouseSKUMppingDetails.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            InputProps={{ readOnly: !permissionList.isFactoryFilterEnabled }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="warehouseID">
                                                            Warehouse
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.warehouseID && errors.warehouseID)}
                                                            fullWidth
                                                            helperText={touched.warehouseID && errors.warehouseID}
                                                            name="warehouseID"
                                                            size='small'
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={WarehouseSKUMppingDetails.warehouseID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--Select Warehouse--</MenuItem>
                                                            {generateDropDownMenu(warehouses)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="budgetCodeID">
                                                            Account Code Name
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.budgetCodeID && errors.budgetCodeID)}
                                                            fullWidth
                                                            helperText={touched.budgetCodeID && errors.budgetCodeID}
                                                            size='small'
                                                            name="budgetCodeID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={WarehouseSKUMppingDetails.budgetCodeID}
                                                            variant="outlined"
                                                            id="budgetCodeID"
                                                        >
                                                            {generateDropDownMenu(budgetCodes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="skuCategoryID">
                                                            SKU Category
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.skuCategoryID && errors.skuCategoryID)}
                                                            fullWidth
                                                            helperText={touched.skuCategoryID && errors.skuCategoryID}
                                                            size='small'
                                                            name="skuCategoryID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={WarehouseSKUMppingDetails.skuCategoryID}
                                                            variant="outlined"
                                                            id="skuCategoryID"
                                                        >
                                                            <MenuItem value="0">--Select SKU Category--</MenuItem>
                                                            {generateDropDownMenu(SKUCategoryNames)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="skuMasterID">
                                                            SKU
                                                        </InputLabel>
                                                        <CustomMultiSelect
                                                            error={Boolean(touched.skuMasterID && errors.skuMasterID)}
                                                            helperText={touched.skuMasterID && errors.skuMasterID}
                                                            items={skuArray}
                                                            getOptionLabel={getOptionLabel}
                                                            getOptionDisabled={getOptionDisabled}
                                                            selectedValues={selectedOptions}
                                                            placeholder="--Select SKU--"
                                                            selectAllLabel="Select All"
                                                            onToggleOption={handleToggleOption}
                                                            onClearOptions={handleClearOptions}
                                                            onSelectAll={handleSelectAll}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                            <Box minWidth={1050}>
                                                {mappingViewData.length > 0 ? (
                                                    <MaterialTable
                                                        title="Multiple Actions Preview"
                                                        columns={[
                                                            { title: 'Warehouse', field: 'warehouseName' },
                                                            { title: 'Account Code Name', field: 'budgetCodeName' },
                                                            { title: 'SKU Category', field: 'skuCategoryName' },
                                                            { title: 'SKU', field: 'skuMasterName' },
                                                            { title: ' Purchase Category', field: 'purchaseCategoryName' },
                                                            // { title: 'Store Warehouse', field: 'storeWarehouseName' },
                                                        ]}
                                                        data={mappingViewData}
                                                        options={{
                                                            exportButton: false,
                                                            showTitle: false,
                                                            headerStyle: { textAlign: "left", height: '1%' },
                                                            cellStyle: { textAlign: "left" },
                                                            columnResizable: false,
                                                            actionsColumnIndex: -1,
                                                            pageSize: 10
                                                        }}
                                                        actions={[
                                                            {
                                                                //icon: 'delete',
                                                                tooltip: 'Delete',
                                                                icon: () => <CloseIcon style={{ color: 'red' }} />,
                                                                onClick: (event, rowData) => handleClickDelete(rowData)
                                                            }
                                                        ]}
                                                    />
                                                ) : null}
                                            </Box>

                                            {mappingViewData.length > 0 && (
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        type="submit"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorRecord}
                                                        onClick={() => createFile()}
                                                        size='small'
                                                    >
                                                        EXCEL
                                                    </Button>
                                                </Box>
                                            )}
                                            <Dialog open={deleteConfirmationOpen} onClose={handleCancelDelete}>
                                                <DialogTitle>
                                                    <h2>Delete Confirmation</h2>
                                                </DialogTitle>
                                                <DialogContent>
                                                    <p>Are you sure you want to delete this record?</p>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleConfirmDelete} color="primary">
                                                        Delete
                                                    </Button>
                                                    <Button onClick={handleCancelDelete} color="primary">
                                                        Cancel
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page >
        </Fragment >
    )
}